
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import DlgTrainingNew from '@/modules/admin/trainings/_components/DlgTrainingNew.vue';
  import Card from '@/components/material/Card.vue';
  import DlgTrainingDelete from '@/modules/admin/trainings/_components/DlgTrainingDelete.vue';

  @Component({
    components: {DlgTrainingDelete, Card, DlgTrainingNew},
  })
  export default class VTrainingList extends Vue {
    @Action('admin/trainings/read') private readAll!: any;

    @Getter('admin/trainings/all') private trainings!: any;

    private headers: any = [
      {
        text: 'Titel',
        align: 'left',
        value: 'title',
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
      },
    ];
    private loading: boolean = false;
    private search: string = '';

    private async mounted() {
      this.loading = true;
      await this.readAll();
      this.loading = false;
    }
  }
